"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Engine_1 = require("./modules/Engine");
var AdvDate_1 = require("./lib/AdvDate");
var Parameters_1 = require("./modules/Parameters");
var EngineResults_1 = require("./EngineResults");
var LifeTable_1 = require("./modules/LifeTable");
var InsuranceTable_1 = require("./modules/InsuranceTable");
var InvestmentOptionList_1 = require("./modules/InvestmentOptionList");
var IncomeTaxScheme_1 = require("./modules/IncomeTaxScheme");
var NodeEngine = (function () {
    function NodeEngine() {
    }
    Object.defineProperty(NodeEngine, "version", {
        get: function () {
            return "4.0.1";
        },
        enumerable: true,
        configurable: true
    });
    NodeEngine.prototype.loadInputs = function (input) {
        if (this.params === undefined) {
            this.params = new Parameters_1.Parameters();
        }
        for (var key in input) {
            if (input.hasOwnProperty(key)) {
                var value = input[key];
                if (typeof (value) === "string") {
                    var dateMatch = value.match(new RegExp("/", "g"));
                    if (dateMatch && dateMatch.length === 2) {
                        value = new AdvDate_1.AdvDate(value);
                    }
                }
                if (key === "WageInflationIndex" || key === "PriceInflationIndex" || key === "SunSuperTargetIncomeInflationInRetirement") {
                    if (typeof value === "string") {
                        value = value.split(" ").map(parseFloat);
                    }
                    else if (typeof value === "number") {
                        value = [value];
                    }
                }
                var lifeTables = ["AbsLifeTable", "AlternateLifeTable", "SunSuper_50", "SunSuper_10"];
                if (lifeTables.indexOf(key) > -1) {
                    var table = new LifeTable_1.LifeTable();
                    table.initialise(value.startAge, value.male, value.female, value.all);
                    value = table;
                }
                var insuranceTables = [
                    "GovernmentIncomeProtectionTable",
                    "NonGovernmentIncomeProtectionTable",
                    "SunSuperDeathTPDMale",
                    "SunSuperDeathTPDFemale",
                    "VisionIncomeProtection",
                    "EquipDeathPremiums",
                    "EquipTPDPremiums",
                    "EquipDeathCoverTaper",
                    "EquipTPDCoverTaper",
                    "EquipInsurancePremiumSteps",
                    "QSuperDeathTPDDefault",
                    "QSuperDeathTPDPolice",
                    "PoliceIncomeProtectionTable"
                ];
                if (insuranceTables.indexOf(key) > -1) {
                    var table = new InsuranceTable_1.InsuranceTable();
                    table.initialise(value.startAge, value.cost);
                    value = table;
                }
                if (key === "InvestmentOptions") {
                    var list = new InvestmentOptionList_1.InvestmentOptionList();
                    for (var option in value) {
                        if (value.hasOwnProperty(option)) {
                            list.addInvestmentOption(value[option]);
                        }
                    }
                    value = list;
                }
                if (key === "IncomeTaxRates" || key === "IncomeTaxRates_2022" || key === "IncomeTaxRates_2024") {
                    var scheme = new IncomeTaxScheme_1.IncomeTaxScheme();
                    for (var option in value) {
                        if (value.hasOwnProperty(option)) {
                            scheme.addBand(value[option].bandStart, value[option].rate);
                        }
                    }
                    value = scheme;
                }
                this.params.setParam(key, value);
            }
        }
    };
    NodeEngine.prototype.run = function (input) {
        if (input === void 0) { input = undefined; }
        if (input !== undefined) {
            this.loadInputs(input);
        }
        if (this.params === undefined) {
            throw "Load config before running the engine";
        }
        var engine = new Engine_1.Engine(this.params);
        var engineOutput = engine.run();
        return new EngineResults_1.EngineResults(engineOutput, this.params);
    };
    return NodeEngine;
}());
exports.NodeEngine = NodeEngine;
//# sourceMappingURL=NodeEngine.js.map